import React from 'react';

import { useTranslation } from 'react-i18next';

import { Chip } from '@packages/fenrir/components';

export const ScanningBadge: React.FC<{ scanning: boolean }> = ({
  scanning,
}) => {
  const { t } = useTranslation('telemetryScanSchedules');

  const text = scanning ? t('enabled') : t('disabled');
  const statusColor = scanning ? 'status.low' : 'status.unassigned';

  return (
    <Chip
      title={text}
      label={text}
      size="medium"
      sx={{
        backgroundColor: statusColor,
        color: 'common.darkText',
      }}
    />
  );
};
